import { render, staticRenderFns } from "./StatistiqueSousRegie.vue?vue&type=template&id=60e2d95f&scoped=true&"
import script from "./StatistiqueSousRegie.vue?vue&type=script&lang=js&"
export * from "./StatistiqueSousRegie.vue?vue&type=script&lang=js&"
import style0 from "./StatistiqueSousRegie.vue?vue&type=style&index=0&id=60e2d95f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e2d95f",
  null
  
)

export default component.exports